export default "__VITE_ASSET__mLdydAjd__"